import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIProfile {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + "public/api/smartbook/" + nome_metodo;


  }

  getUrlDomainGo(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = "http://localhost:4007/";
    }

    if (location.hostname != "localhost") {

      result = "https://filestransfer.it:4007/";

    }

    return result + nome_metodo;


  }

  getUrlDomainNew(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + nome_metodo;


  }

  /*   constructor ({ url }) {
        console.log ( url );
        httpOk = axios.create({
        baseURL: url,
         headers: { 'Content-Type': 'application/json' }
      })
    } */


  getProfile(username, tokensystem) {
    //var resource = "/getWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);


    let payload = "user=" + username + "&password=" + tokensystem + `&timestamp=${new Date().getTime()}`;

    //const params = new url.URLSearchParams(payload);

    //alert("before post");
    //return httpOk.post(  resource, formData   ) ;
    // alert(username+ " toke:" + tokensystem);
    //return axios.post( `https://services.ebadge.it/public/api/getWorkerInfo?${payload}` , formData ,{  'Access-Control-Allow-Origin': '*','Content-Type': 'multipart/form-data' }   ) ;

    //return axios.post( `http://services.local/public/api/getWorkerInfoWithoutRes?${payload}` , formData ,{  'Access-Control-Allow-Origin': '*','Content-Type': 'multipart/form-data' }   ) ;

    //return axios.post( `https://services.ebadge.it/public/api/getWorkerInfoWithoutRes?${payload}` , formData ,{  'Access-Control-Allow-Origin': '*','Content-Type': 'multipart/form-data' }   ) ;

    return axios.post(`https://services.ebadge.it/public/api/getWorkerInfoWithoutResAlertMsg?${payload}`, formData, { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data' });

  }



  setProfile(username, tokensystem, profile) {
    // var resource = "/setWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("date", new Date().getTime());

    for (var key in profile) {
      // console.log (key,profile[key] );
      formData.append(key, profile[key]);
    }
    //console.log ( formData );
    return axios.post(`https://services.ebadge.it/public/api/setWorkerInfo`, formData, { 'Content-Type': 'multipart/form-data' });

    //return axios.post( `https://services.ebadge.it/public/api/setWorkerInfoWithoutRes` , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

    //return axios.post( `http://services.local/public/api/setWorkerInfoWithoutRes` , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

    //    return httpOk.post(resource, formData   ) ;
  }



  savePassword(username, tokensystem, profile) {
    // var resource = "/setWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);

    for (var key in profile) {
      // console.log (key,profile[key] );
      formData.append(key, profile[key]);
    }
    //console.log ( formData );
    return axios.post(`https://app.emtool.eu/public/api/emt/setWorkerPassword`, formData, { 'Content-Type': 'multipart/form-data' });

    //    return httpOk.post(resource, formData   ) ;
  }



  getProfileUser(username, tokensystem, id) {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("id", id);


    let payload = "user=" + username + "&password=" + tokensystem + "&id=" + id + `&timestamp=${new Date().getTime()}`;

    //const params = new url.URLSearchParams(payload);

    //alert("before post");
    //return httpOk.post(  resource, formData   ) ;
    // alert(username+ " toke:" + tokensystem);

    return axios.post(this.getUrlDomain("getProfileUser") + `?${payload}`, formData, { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data' });


  }


  async getProfileJMCareers(username, tokensystem) {

    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);

    return axios.post(this.getUrlDomainNew("getProfileJMCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  checkPasswordJMCareers(username, profile) {
    let formData = new FormData();
    formData.append("user", username);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainNew("checkPasswordJMCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  savePasswordNewJMCareers(username, tokensystem, profile) {
    // var resource = "/setWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);

    for (var key in profile) {
      // console.log (key,profile[key] );
      formData.append(key, profile[key]);
    }
    //console.log ( formData );
    return axios.post(this.getUrlDomainNew("savePwdJMCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async getProfileCareers(username, tokensystem, v_token) {

    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);

    return axios.post(this.getUrlDomainNew("getProfileCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  setProfileCareersNew(username, tokensystem, profile) {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("date", new Date().getTime());

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainNew("updateProfileCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  savePasswordCareersNew(username, tokensystem, profile, v_token) {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }
    return axios.post(this.getUrlDomainNew("savePwdCareers"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getProfileJobmule(username, tokensystem, v_token) {

    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);

    return axios.post(this.getUrlDomainNew("getProfileJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  checkPasswordJobmule(username, profile, v_token) {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("v_token", v_token);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainNew("checkPassword"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  checkPasswordJobmuleGo(username, profile, v_token) {
    let formData = new FormData();
    formData.append("user", username);
    formData.append("v_token", v_token);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainGo("checkPasswordJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  savePasswordNewJobmule(username, tokensystem, profile, v_token, v_prodotto) {
    // var resource = "/setWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);
    formData.append("v_prodotto", v_prodotto);

    for (var key in profile) {
      // console.log (key,profile[key] );
      formData.append(key, profile[key]);
    }
    //console.log ( formData );
    return axios.post(this.getUrlDomainNew("savePwdJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  savePasswordNewJobmuleGo(username, tokensystem, profile, v_token, v_prodotto) {
  
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);
    formData.append("v_prodotto", v_prodotto);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainGo("savePswJobmule"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async goGetProfileJobmule(username, tokensystem, v_token) {

    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("v_token", v_token);

    return axios.post(this.getUrlDomainGo("getProfile"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  setProfileJobmule(username, tokensystem, profile, logo) {
    // var resource = "/setWorkerInfo" ;
    let formData = new FormData();
    formData.append("user", username);
    formData.append("password", tokensystem);
    formData.append("date", new Date().getTime());
    formData.append("logo", logo);

    for (var key in profile) {
      formData.append(key, profile[key]);
    }

    return axios.post(this.getUrlDomainGo("updateProfile"), formData, { 'Content-Type': 'multipart/form-data' });

  }

}

export default new APIProfile({
  url: "https://services.ebadge.it/public/api/"
})
